// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"TableHeaderCell-headerCell-DbapO","sortIcon":"TableHeaderCell-sortIcon-MClfQ"};